module.exports = __webpack_public_path__ + "static/media/qualityInspectionRequirements.d79f4dd2.pdf";